// Tarjetas del selector de portal, una por destino de `portalAccess`. Labels y descripciones son
// copy visible (es-MX); el orden lo da PORTALS.
import { linkOptions, type LinkOptions } from '@tanstack/react-router';
import { AppWindow, DollarSign, Smartphone, Users, type LucideIcon } from 'lucide-react';
import type { PortalId } from './portalAccess';

export interface RoleEntry {
    label: string;
    description: string;
    /** Destino type-safe (spread directo en <Link>) — crear con `linkOptions()`. */
    link: LinkOptions;
    Icon: LucideIcon;
    /** Clases del cuadro del ícono (fondo + color). */
    iconClass: string;
}

export const ROLE_ENTRIES: Record<PortalId, RoleEntry> = {
    'retail-admin': {
        label: 'Admin VentasLuga',
        description:
            'Operación diaria: ventas, clientes, tiendas, vendedores, inventario, análisis',
        link: linkOptions({ to: '/retail-admin' }),
        Icon: AppWindow,
        iconClass: 'bg-blue-100 text-blue-600',
    },
    credit: {
        label: 'Admin SureKeep',
        description: 'SOFOM: planes, scoring, cobranza, reestructuras, bajas',
        link: linkOptions({ to: '/credit' }),
        Icon: DollarSign,
        iconClass: 'bg-emerald-100 text-emerald-600',
    },
    sales: {
        label: 'Vendedor',
        description: '1 tienda: wizard + pagos en efectivo',
        link: linkOptions({ to: '/sales' }),
        Icon: Smartphone,
        iconClass: 'bg-amber-100 text-amber-600',
    },
    admin: {
        label: 'Administración',
        description: 'Usuarios, roles y seguridad de tu organización',
        link: linkOptions({ to: '/tenant/users' }),
        Icon: Users,
        iconClass: 'bg-slate-100 text-slate-700',
    },
};
